// Local translations
export const T = {
  en_GB: {
    previousAnswerFound: "Previous Answer Found",
    answeredOn: (date: string) => `You answered this question on ${date}`,
    applying: "Applying...",
    usePreviousAnswer: "Use Previous Answer",
    startFresh: "Start Fresh",
    wantsProfessionalClient: "I want to be classified as a Professional client",
    toQualifyAllCriteria: "To qualify, you must meet ALL 3 criteria:",
    significantTransactions: "Made 10+ significant transactions per quarter in the past year",
    largePortfolio: "Investment portfolio exceeds €500,000 (securities + cash)",
    financeExperience: "Work/worked 1+ year in finance in a role requiring investment knowledge",
    progress: "Progress:",
    ofCriteria: (count: number) => `${count} of 3 criteria`,
    isFinancialInstitution: "Is this a regulated financial institution?",
    financialInstitutionExamples:
      "(Bank, investment firm, insurance company, government body, central bank)",
    yes: "Yes",
    no: "No",
    largeCompanyCriteria: "Large company criteria",
    largeCompanyDescription:
      "Select the criteria the company meets (2 of 3 required for Professional status)",
    balanceSheet: "Balance sheet total > €20,000,000",
    netRevenue: "Net revenue > €40,000,000",
    ownFunds: "Own funds/equity > €2,000,000",
    classificationResult: "Classification Result",
    personProfessionalExplanation: "Individual meets all 3 opt-up criteria per MiFID II",
    personAllCriteriaRequired: (count: number) =>
      `All 3 criteria required for Professional status (${count}/3 met)`,
    personRetailExplanation:
      "Individual clients are classified as Retail by default under MiFID II",
    groupRetailExplanation:
      "Groups of natural persons are classified as Retail by default under MiFID II",
    companyEligibleCounterparty: "Regulated financial institution per MiFID II",
    companyProfessional: (count: number) =>
      `Large company meeting ${count} of 3 criteria per MiFID II`,
    companyRetailProgress: (count: number) =>
      `Company meets ${count} of 3 large company criteria (2 required for Professional)`,
    pleaseAnswer: "Please answer the questions above to determine classification",
    // Follow-up A — error highlighting message (D12, per-widget specific).
    incompleteMessage: "Determine the client classification",
    repNote: (name: string) =>
      `Criteria concerning knowledge and experience refer to ${name}, who acts on behalf of the client.`,
    repNoteViaMember:
      "Criteria concerning knowledge and experience refer to {name} ({role}), on behalf of {member}, who acts for the group.",
    repGeneric: "the client's representative",
    reuseNoLongerAvailable: "Reuse is no longer available.",
  },
  nb_NO: {
    previousAnswerFound: "Tidligere svar funnet",
    answeredOn: (date: string) => `Du besvarte dette spørsmålet den ${date}`,
    applying: "Bruker...",
    usePreviousAnswer: "Bruk tidligere svar",
    startFresh: "Start på nytt",
    wantsProfessionalClient: "Jeg ønsker å bli klassifisert som profesjonell kunde",
    toQualifyAllCriteria: "For å kvalifisere må du oppfylle ALLE 3 kriteriene:",
    significantTransactions: "Gjennomført 10+ betydelige transaksjoner per kvartal det siste året",
    largePortfolio: "Investeringsportefølje over €500 000 (verdipapirer + kontanter)",
    financeExperience:
      "Arbeider/arbeidet 1+ år i finans i en rolle som krever investeringskunnskap",
    progress: "Fremgang:",
    ofCriteria: (count: number) => `${count} av 3 kriterier`,
    isFinancialInstitution: "Er dette en regulert finansinstitusjon?",
    financialInstitutionExamples:
      "(Bank, verdipapirforetak, forsikringsselskap, offentlig organ, sentralbank)",
    yes: "Ja",
    no: "Nei",
    largeCompanyCriteria: "Kriterier for store foretak",
    largeCompanyDescription:
      "Velg kriteriene selskapet oppfyller (2 av 3 kreves for profesjonell status)",
    balanceSheet: "Balansesum > €20 000 000",
    netRevenue: "Netto omsetning > €40 000 000",
    ownFunds: "Egenkapital > €2 000 000",
    classificationResult: "Klassifiseringsresultat",
    personProfessionalExplanation:
      "Privatperson oppfyller alle 3 oppgraderingskriteriene i henhold til MiFID II",
    personAllCriteriaRequired: (count: number) =>
      `Alle 3 kriteriene kreves for profesjonell status (${count}/3 oppfylt)`,
    personRetailExplanation:
      "Privatpersoner klassifiseres som ikke-profesjonelle som standard i henhold til MiFID II",
    groupRetailExplanation:
      "Grupper av privatpersoner klassifiseres som ikke-profesjonelle som standard i henhold til MiFID II",
    companyEligibleCounterparty: "Regulert finansinstitusjon i henhold til MiFID II",
    companyProfessional: (count: number) =>
      `Stort foretak som oppfyller ${count} av 3 kriterier i henhold til MiFID II`,
    companyRetailProgress: (count: number) =>
      `Selskapet oppfyller ${count} av 3 kriterier for store foretak (2 kreves for profesjonell)`,
    pleaseAnswer: "Vennligst besvar spørsmålene ovenfor for å fastsette klassifisering",
    incompleteMessage: "Fastsett klientklassifiseringen",
    repNote: (name: string) =>
      `Kriterier som gjelder kunnskap og erfaring, viser til ${name}, som handler på vegne av kunden.`,
    repNoteViaMember:
      "Kriterier som gjelder kunnskap og erfaring, viser til {name} ({role}), på vegne av {member}, som handler for gruppen.",
    repGeneric: "kundens representant",
    reuseNoLongerAvailable: "Gjenbruk er ikke lenger tilgjengelig.",
  },
} as const;
